import { Accordion } from './../front-end/_accordion';

window.addEventListener( 'load', function() {
	'use strict';

	// Set up the accordions.
	var locationIndexAccordion = new Accordion( {
		element: '.location-index .section > .readmore',
		oneOpen: false
	} );

	var coverageLists = document.querySelectorAll( '.location-index .section > .readmore' );

	if ( coverageLists === null || coverageLists === undefined ) {
		return;
	}

	[].forEach.call( coverageLists, function( el ) {

		var additional = el.getElementsByClassName( 'additional' )[0],
			listHeight = el.offsetHeight,
			additionalHeight = additional.offsetHeight;

		// If there's hidden content, show the Read More button.
		if ( additionalHeight > listHeight ) {
			el.getElementsByClassName( 'toggle' )[0].style.opacity = '1';
		} else {
			el.getElementsByClassName( 'toggle' )[0].style.display = 'none';
		}
	} );

} );
